import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74949748"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }

import { appStore } from '@/store/appStore';
	import { computed, onMounted, reactive, ref } from 'vue';
	
export default /*#__PURE__*/_defineComponent({
  __name: 'Appsettings',
  setup(__props) {

	const store = appStore()
	const setting = reactive({
		// theme: "green",
		// themelight:"light"
	})
	const theme = ["blue", "green", "red", "pink"]


	function selectedImgFormart(item) {
		store.color = item;
		store.toogleColor(item);
	}
	function selectedDark(item){
		store.theme = item;
		store.toogleDark(item);
	}
	function waguan(item){
		store.toogleWG(item);
	}
	function yulanzhi(item){
		store.settingMaxzhi(item);
	}

return (_ctx: any,_cache: any) => {
  const _component_x_label = _resolveComponent("x-label")!
  const _component_x_menuitem = _resolveComponent("x-menuitem")!
  const _component_x_menu = _resolveComponent("x-menu")!
  const _component_x_select = _resolveComponent("x-select")!
  const _component_x_box = _resolveComponent("x-box")!
  const _component_x_card = _resolveComponent("x-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_x_card, { style: {"width":"96%","max-width":"750px","padding-bottom":"24px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_x_box, { style: {"margin":"14px 15px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_x_label, { style: {"flex-shrink":"1","margin":"0 15px","width":"110px"} }, {
              default: _withCtx(() => [
                _createTextVNode("主题设置")
              ]),
              _: 1
            }),
            _createVNode(_component_x_select, {
              style: {"min-width":"90px"},
              value: _unref(store).color
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_menu, null, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(theme, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (item=='green')
                          ? (_openBlock(), _createBlock(_component_x_menuitem, {
                              key: 0,
                              onClick: ($event: any) => (selectedImgFormart(item)),
                              toggled: "",
                              value: item
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_x_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "value"]))
                          : (_openBlock(), _createBlock(_component_x_menuitem, {
                              key: 1,
                              onClick: ($event: any) => (selectedImgFormart(item)),
                              value: item
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_x_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "value"]))
                      ], 64))
                    }), 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_x_box, { style: {"margin":"14px 15px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_x_label, { style: {"flex-shrink":"1","margin":"0 15px","width":"110px"} }, {
              default: _withCtx(() => [
                _createTextVNode("暗夜设定")
              ]),
              _: 1
            }),
            _createVNode(_component_x_select, {
              style: {"min-width":"90px"},
              value: _unref(store).theme
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_x_menuitem, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedDark('dark'))),
                      value: "dark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_x_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("暗黑")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_x_menuitem, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedDark('light'))),
                      value: "light"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_x_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("白昼")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_x_box, { style: {"margin":"14px 15px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_x_label, { style: {"flex-shrink":"1","margin":"0 15px","width":"110px"} }, {
              default: _withCtx(() => [
                _createTextVNode("外观设定")
              ]),
              _: 1
            }),
            _createVNode(_component_x_select, {
              style: {"min-width":"90px"},
              value: _unref(store).waiguan
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_x_menuitem, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (waguan('adwaita'))),
                      value: "adwaita"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_x_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Mdesign")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_x_menuitem, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (waguan('cupertino'))),
                      value: "cupertino"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_x_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Mac")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_x_menuitem, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (waguan('fluent'))),
                      value: "fluent"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_x_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Liunx")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_x_box, { style: {"margin":"14px 15px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_x_label, { style: {"flex-shrink":"1","margin":"0 15px","width":"110px"} }, {
              default: _withCtx(() => [
                _createTextVNode("最大内存预览值")
              ]),
              _: 1
            }),
            _createVNode(_component_x_select, {
              style: {"min-width":"90px"},
              value: _unref(store).maxZhi
            }, {
              default: _withCtx(() => [
                _createVNode(_component_x_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_x_menuitem, {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (yulanzhi(1.5))),
                      value: "1.5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_x_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("1.5MB+")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_x_menuitem, {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (yulanzhi(5))),
                      value: "5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_x_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("5MB+")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_x_menuitem, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (yulanzhi(10))),
                      value: "10"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_x_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("10MB+")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_x_label, { style: {"flex-shrink":"1","margin":"0 15px"} }, {
          default: _withCtx(() => [
            _createTextVNode("是指：打开图片预览时，如果本地图片超过这个值就会进行程序压缩预览，以免浏览器卡。压缩是通过内置程序自动压缩预览。不会上传到服务器压缩，放心。")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})